import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowDownToLineIcon, MailIcon, MapPinIcon } from 'lucide-react';
import { PROFILE } from '../data/profile';
import { PortraitFrame } from './PortraitFrame';
const SEATS = ['Independent Board Director', 'Audit Committee', 'Risk Committee', 'Strategic Advisory'];
export function Hero() {
  return <section className="relative isolate w-full overflow-hidden bg-navy-950" data-id="element-204" data-mp="12a0kd8y2xwtk">
      <img src={PROFILE.architecture} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-30" data-id="element-205" data-mp="xae7x1q2sklt" />
      <div aria-hidden="true" className="absolute inset-0" style={{
      backgroundImage: 'linear-gradient(180deg, rgba(6,15,31,0.94) 0%, rgba(6,15,31,0.9) 55%, rgba(6,15,31,0.98) 100%)'
    }} data-id="element-206" data-mp="s9giq56neqat" />

      <div className="relative mx-auto max-w-content px-6 pb-24 pt-44 sm:pb-28 sm:pt-52 lg:px-8 xl:pt-60" data-id="element-207" data-mp="381xlmzcsr4ap">
        <motion.div initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.75,
        ease: [0.22, 1, 0.36, 1]
      }} className="flex flex-col items-center" data-id="element-208" data-mp="3j897lcz58bpj">
          <span className="text-[11px] font-medium uppercase tracking-widest text-gold-400" data-id="element-209" data-mp="399thndbur8hm">
            Section 04 · Executive Hero &amp; Board Positioning
          </span>

          <div className="mt-14" data-id="element-210" data-mp="30gzuyuu2t6tq">
            <PortraitFrame tone="dark" size="lg" data-id="element-211" data-mp="30fy87t3p6vw6" />
          </div>

          <p className="mx-auto mt-9 max-w-2xl text-center text-[15px] leading-relaxed text-slateink-300 sm:text-base" data-id="element-212" data-mp="359sy5e9wc73p">
            {PROFILE.subHeadline}
          </p>

          <ul className="mt-10 flex flex-wrap justify-center gap-x-3 gap-y-3" data-id="element-213" data-mp="2viojkfo4uo9e">
            {SEATS.map(seat => <li key={seat} className="border border-white/15 px-4 py-2 text-[11px] uppercase tracking-wider text-slateink-300" data-id="element-214" data-mp="2hix224yeqpqn">
                {seat}
              </li>)}
          </ul>

          <div className="mt-12 flex flex-col gap-4 sm:flex-row sm:items-center" data-id="element-215" data-mp="s44itpsj1piy">
            <a href={`mailto:${PROFILE.email}?subject=Board%20Bio%20%2F%20CV%20Request`} className="inline-flex items-center justify-center gap-2.5 bg-gold-500 px-8 py-4 text-[12px] font-semibold uppercase tracking-wider text-navy-950 transition-colors hover:bg-gold-400" data-id="element-216" data-mp="n9qf903poc37">
              <ArrowDownToLineIcon className="h-4 w-4" aria-hidden="true" data-id="element-217" data-mp="1ayt7f1vz1nby" />
              Download Board Bio / CV
            </a>
            <Link to="/contact" className="inline-flex items-center justify-center gap-2.5 border border-white/25 px-8 py-4 text-[12px] font-semibold uppercase tracking-wider text-white transition-colors hover:border-white hover:bg-white/5" data-id="element-218" data-mp="112g6pk20e97p">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-219" data-mp="3hrd8esqpz5yu" />
              Get in Touch
            </Link>
          </div>

          <p className="mt-10 flex items-center gap-2 text-[13px] text-slateink-300" data-id="element-220" data-mp="1x9ukuaytndnf">
            <MapPinIcon className="h-4 w-4 text-gold-500" aria-hidden="true" data-id="element-221" data-mp="21amvn8ncdqlt" />
            {PROFILE.location}
          </p>
        </motion.div>
      </div>
    </section>;
}